import { PositionStaffFragment } from "gql/graphql";
import { Hidable, NotSpecified, Value } from "@/shared/value";

/**
 * Штатная численность должности — доля ставки, поэтому всегда с двумя знаками:
 * «1» и «0.5» рядом в списке читаются как разные единицы измерения.
 */
export function PositionStaff({
  data,
}: {
  data?: Hidable<PositionStaffFragment>;
}) {
  return (
    <Value data={data}>
      {(position) =>
        position.positionStaff === null ||
        position.positionStaff === undefined ? (
          <NotSpecified />
        ) : (
          <span>{position.positionStaff.toFixed(2)}</span>
        )
      }
    </Value>
  );
}
